import { render, staticRenderFns } from "./potongan.vue?vue&type=template&id=a105270e"
import script from "./potongan.vue?vue&type=script&lang=js"
export * from "./potongan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports